export const possibleWinningMax: number = 300000;
